'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'far';
var iconName = 'house-chimney';
var width = 512;
var height = 512;
var aliases = [63499,"home-lg"];
var unicode = 'e3af';
var svgPathData = 'M272 6.1c-9.1-8.2-22.9-8.2-32 0L8 214.1c-9.9 8.8-10.7 24-1.8 33.9s24 10.7 33.9 1.8l8-7.2 0 205.3c0 35.3 28.7 64 64 64l288 0c35.3 0 64-28.7 64-64l0-205.3 8 7.2c9.9 8.8 25 8 33.9-1.8s8-25-1.8-33.9l-40-35.9 0-90.2c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 47.2-144-129.1zM416 199.7L416 448c0 8.8-7.2 16-16 16l-48 0 0-104c0-39.8-32.2-72-72-72l-48 0c-39.8 0-72 32.2-72 72l0 104-48 0c-8.8 0-16-7.2-16-16L96 199.7 256 56.2 416 199.7zM208 464l0-104c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 104-96 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faHouseChimney = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;